<template>
  <section class="content-section">
    <a-step
      :leadin="leadin"
      step="2"
      cssclass="content__heading lessmargin"
      header="Persönliche Daten"
    />
    <a-form class="info-form form" ref="personForm">
      <div class="container form__upper">
        <div v-if="leadin.errorMessage.message" class="afterSendError">{{ leadin.errorMessage.message }}</div>
        <div class="form__section">
          <div class="fieldset half">
            <a-input
              label="Anrede"
              v-model="gender"
              type="select"
              :options="genderList"
              required
              :rules="[rules.notEmpty]"
              :readonly="leadin.isUDSelling"
            />
          </div>
          <div class="fieldset">
            <a-input
              required
              label="Vorname"
              v-model="firstname"
              :rules="[rules.notEmpty, rules.toLong]"
              :readonly="leadin.isUDSelling"
            />
            <a-input
              required
              label="Nachname"
              v-model="lastname"
              :rules="[rules.notEmpty, rules.toLong]"
              :readonly="leadin.isUDSelling"
            />
          </div>
          <div class="fieldset half date form--unlarge">
            <a-input
              required
              label="Geburtsdatum"
              v-model="birthday"
              type="date"
              :rules="ageRule"
              yeartype="adult"
              :readonly="leadin.isUDSelling"
            />
          </div>
          <div class="fieldset">
            <a-input
              required
              label="Telefonnummer"
              v-model="phone"
              type="tel"
              :eclass="leadin.errorMessage.phone"
              :rules="[rules.notEmpty, rules.toShort]"
              :readonly="leadin.isUDSelling"
            />
            <a-input
              required
              label="E-Mail Adresse"
              v-model="email"
              type="email"
              :rules="[rules.notEmpty, rules.email, rules.toLong]"
              :readonly="leadin.isUDSelling"
            />
          </div>
          <div class="form__row"></div>
          <div class="fieldset address">
            <a-input
              required
              class="street"
              label="Strasse"
              v-model="street"
              :rules="[rules.notEmpty]"
              :readonly="leadin.isUDSelling"
            />
            <a-input
              required
              class="snr"
              label="Hausnummer"
              v-model="number"
              :readonly="leadin.isUDSelling"
            />
            <!--  :rules="streetNumber" -->
          </div>
          <div class="fieldset address">
            <a-input
              required
              class="zip"
              label="PLZ"
              v-model="zip"
              type="tel"
              :rules="zipRule"
              :readonly="leadin.isUDSelling"
            />
            <a-input
              required
              label="Ort"
              v-model="city"
              :rules="[rules.notEmpty, rules.toLong]"
              :readonly="leadin.isUDSelling"
              @blur="pushDataLayer('persoenliche_daten', 'ort', $event.value)"
            />
          </div>

          <div class="fieldset half">
            <a-input
              label="Land"
              v-model="country"
              type="select"
              :options="countryList"
              required
              :rules="[rules.notEmpty]"
              :readonly="leadin.isUDSelling"
              v-on:input="pushDataLayer('persoenliche_daten','country', country)"
            />
          </div>
        </div>
        <div class="form__section form__section--agreement">
          <div class="agreement">
            <div class="agreement__confirmation">
                <h2>Was können wir sonst noch für {{ leadin.petname }} tun?</h2>
                <p>Gern halten wir Sie über neue Produkte und Angebote für {{ leadin.petname }} auf dem Laufenden (optional)</p>
                <p>Ich möchte:</p>
                <p>
                  <label class="custom-checkbox">
                    <input type="checkbox" v-model="newsletter" v-on:input="pushDataLayer('ecommerce','newsletter', !newsletter)" id="cbNewsletter" />
                    <span class="fake-checkbox">
                      <i class="icon-check"></i>
                    </span>
                    <span class="fake-label gray-label inline-checkbox"
                    >den Newsletter erhalten</span
                    >
                  </label>
                </p>
                <p>
                  <label class="custom-checkbox">
                    <input type="checkbox" v-model="addagreement" v-on:input="pushDataLayer('ecommerce','addagreement', !addagreement)" id="cbAddAgreement" />
                    <span class="fake-checkbox">
                      <i class="icon-check"></i>
                    </span>
                    <span class="fake-label gray-label inline-checkbox"
                    >per Telefon/SMS informiert werden</span
                    >
                  </label>
                </p>
                <p>
                  <label class="custom-checkbox">
                    <input type="checkbox" v-model="survey" v-on:input="pushDataLayer('ecommerce','survey', !survey)" id="cbSurvey" />
                    <span class="fake-checkbox">
                      <i class="icon-check"></i>
                    </span>
                    <span class="fake-label gray-label inline-checkbox"
                    >an Umfragen teilnehmen</span
                    >
                  </label>
                </p>
                <p>
                  <span class="inline-checkbox explain">
                    Meine Einwilligung zur entsprechenden Speicherung und Verwendung meiner angegebenen
                    personenbezogenen Daten ist freiwillig und kann von mir jederzeit mit Wirkung für die Zukunft
                    formlos gegenüber der AGILA Haustierversicherung AG (AGILA Haustierversicherung AG, Breite Str. 6-8,
                    30159 Hannover, Deutschland,                    <a href="mailto:widerruf@agila.de">widerruf@agila.de</a> oder
                    telefonisch unter
                    <a
                        v-if="country != 'Österreich'"
                        href="tel:+49 511 93680377"
                    >+49 511 93680377</a
                    ><a v-if="country == 'Österreich'" href="tel:00800-71280-345"
                  >00800-71280-345</a
                  >) widerrufen. Weitere Informationen zur Verarbeitung Ihrer Daten und zur Ausübung Ihres Widerrufsrechts finden Sie unter                    <a href="https://www.agila.de/datenschutz" target="_blank"
                  >Datenschutz</a
                  >.
                   </span>
                </p>
              <template v-if="optimizelyIsVariant(5597786670891008, 4712802670084096)">
                <h2>Nachhaltige Kommunikation aus Liebe zur Umwelt</h2>
                <p>
                  <label class="custom-checkbox">
                    <input type="checkbox" v-model="digitalCommunication" id="cbDigitalCommunication" />
                    <span class="fake-checkbox">
                      <i class="icon-check"></i>
                    </span>
                    <span class="fake-label gray-label inline-checkbox"
                    >Ja, ich möchte in Zukunft alle Mitteilungen zu meinem Vertrag per E-Mail erhalten. Meine Zustimmung zur digitalen Vertragskommunikation kann ich jederzeit über das Help Center widerrufen. (optional)</span>
                  </label>
                </p>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="form__links">
        <div class="container">
          <div class="form__btn">
            <div class="form__btn-holder">
              <a-btn primary dark @click="submitBottom" class="btn btn--green"
                >Weiter</a-btn
              >
            </div>
            <a v-if="!leadin.contract_id"
              v-on:click="$parent.back(1, 'tier'); pushDataLayer('persoenliche_daten','go_back', 'tier')"
              class="form__back-link back-link"
              >
              <span class="back-link__icon icon-left-arrow"></span>Vorheriger Schritt
            </a>
          </div>
        </div>
      </div>
    </a-form>
  </section>
</template>

<script>
import dialog from '../helpers/dialog.js'
import NoNumber from '../components/Modal/NoStreetNumber'
import {entryChannel} from "@/vars";
import {puppyEntry, setPuppy} from "../vars";

export default {
  model: {
    prop: "leadin",
    event: "leademit",
  },
  props: {
    registry: {
      type: Object,
      default() {
        return {};
      },
    },
    leadin: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data: () => ({
    firstname: "",
    lastname: "",
    petname: "",
    gender: "",
    birthday: "",
    email: "",
    phone: "",
    street: "",
    number: "",
    numberN: false,
    trigNumberN: false,
    zip: "",
    city: "",
    country: "",
    newsletter: false,
    survey: false,
    addagreement: false,
    digitalCommunication: false,
    countryList: [
      { label: "Deutschland", value: "Deutschland" },
      { label: "Österreich", value: "Österreich" },
    ],
    genderList: [
      { label: "Frau", value: "Frau" },
      { label: "Herr", value: "Herr" },
      { label: "Divers", value: "Divers" },
    ],
    rules: {
      notEmpty: function (v) {
        return v && !null ? true : "Darf nicht leer sein!";
      },
      sNumber: function (v) {
        return v && !null ? true : "Darf nicht leer sein!!";
      },
      toYoung: function (v) {
        return v
          ? "Sie müssen mindestens 18 Jahre alt sein."
          : "Sie müssen mindestens 18 Jahre alt sein.";
      },
      wrongZip: function (v) {
        return v
          ? "Bitte geben Sie eine korrekte Postleitzahl ein."
          : "Bitte geben Sie eine korrekte Postleitzahl ein.";
      },
      toLong: function (v) {
        return v && v.length < 50 ? true : "Die Eingabe ist zu lang";
      },
      toShort: function (v) {
        let v1 = v.replace(/\s/g,'')
        let regEx = /^(\+)?[(0-9][- ()0-9]{3,14}[0-9]{3}$/
        return v && v1.match(regEx) ? true : "Die Telefonnummer nicht korrekt";
      },
      email: function (v) {
        const re =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!re.test(String(v).toLowerCase())) {
          return "Ihre E-Mail-Adresse ist nicht valide.";
        }

        return true;
      },
    },
  }),
  mounted: function () {

    this.birthday = this.leadin.birthday;
    if (this.leadin.birthday == undefined) {
      this.leadin.birthday = new Date();
      this.leadin.birthday.setDate(this.leadin.birthday.getDate() - 365.25 * 18);
    }
  },
  watch: {
    leadin: {
      immediate: true,
      handler(to) {
        this.firstname = to.firstname;
        this.lastname = to.lastname;
        this.petname = to.petname;
        this.gender = to.gender;
        this.birthday = to.birthday;
        this.email = to.email;
        this.phone = to.phone;
        this.street = to.street;
        this.number = to.number;
        this.zip = to.zip;
        this.city = to.city;
        this.country = to.country;
        this.newsletter = to.newsletter;
        this.survey = to.survey;
        this.addagreement = to.addagreement;
        this.numberN = (to.numberN != undefined)? to.numberN: false;
      },
    },
  },
  computed: {
    ageRule() {
      let rules = [];

      if (!this.birthday) {
        rules.push(this.rules.notEmpty);
      } else {
        const today = new Date();
        const selectedDate = new Date(this.birthday);
        const age = today.getFullYear() - selectedDate.getFullYear();
        const monthDiff = today.getMonth() - selectedDate.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < selectedDate.getDate())) {
          if (age - 1 < 18) {
            rules.push(this.rules.toYoung);
          }
        }

        if (age < 18) {
          rules.push(this.rules.toYoung);
        }
      }

      return rules;
      /*const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


            if (!re.test(String(this.lead.email).toLowerCase())){
                this.lead.error.email = "Ihre E-Mail-Adresse ist nicht valide."
                error = true;
            }*/
    },
    zipRule() {
      let rules = [];

      if (!this.zip) {
        rules.push(this.rules.notEmpty);
      } else {
        let len = 5;

        if (this.country == "Österreich") {
          len = 4;
        }

        if (len != this.zip.length) {
          rules.push(this.rules.wrongZip);
        }

        if (!Number.isInteger(1 * this.zip)) {
          rules.push(this.rules.wrongZip);
        }
      }

      return rules;
    }
  },
  methods: {
    submitBottom() {
      if (this.numberN == false && (this.number == '' || this.number == undefined)){
        // eslint-disable-next-line vue/no-async-in-computed-properties
        dialog.component(NoNumber, {
          }, 0, 500).then(result => {
              if (result === true) {
                this.numberN = true
              }
              else {
                this.numberN = false
              }
          })
          document.getElementById("jumppoint").scrollIntoView();
          return false;
      }

      if (this.$refs.personForm.validate()) {
        this.leadin.firstname = this.firstname;
        this.leadin.lastname = this.lastname;
        this.leadin.petname = this.petname;
        this.leadin.gender = this.gender;
        this.leadin.birthday = this.birthday;
        this.leadin.email = this.email;
        this.leadin.phone = this.phone;
        this.leadin.street = this.street;
        this.leadin.number = this.number;
        this.leadin.zip = this.zip;
        this.leadin.city = this.city;
        this.leadin.country = this.country;
        this.leadin.newsletter = this.newsletter;
        this.leadin.survey = this.survey;
        this.leadin.addagreement = this.addagreement;
        this.leadin.numberN = this.numberN;
        this.leadin.digitalCommunication = this.digitalCommunication;

        // 6 months
        if (puppyEntry) {
          let seconds = this.calcAgeInSeconds(this.leadin.petbirthday)
          if (seconds > 15780000) {
            setPuppy(false);
          } else {
            setPuppy(true);
          }
        }

        // Tracking Start
        if (
            this.registry.cc &&
            (this.registry.cc.includes("gat") ||
                this.registry.cc.includes("all") ||
                this.registry.cc.includes("marketing"))
        ) {
          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ecommerce: null})
            window.dataLayer.push({
              event: "add_shipping_info",
              ecommerce: {
                details: {
                  currency: "EUR",
                  value: this.leadin.productPrice,
                  antragsstrecke_ueber: entryChannel,
                  customer: {
                    city: this.city,
                    country: this.country,
                    mail: this.email,
                    telefon: this.phone
                  },
                  pet: {
                    rasse: this.leadin.breed,
                    alter: this.calculateAge(this.leadin.petbirthday),
                    geschlecht: this.leadin.petgender,
                    tierart: this.leadin.race == '1' ? "Hund" : "Katze",
                  }
                },
                items: this.getTrackingProductItems()
              }
            });
          } catch (e) {
            console.error(e);
          }
        }
        // Tracking End

        this.$parent.advance("advancePerson", true);
        this.$emit("leademit", this.leadin);
        return true;
      } else {
        document.getElementById("jumppoint").scrollIntoView();
      }
      return false;
    },
  },
};
</script>

<style scoped>
.agreement__confirmation {
  text-align: justify;
  font-size: 16px;
}

@media (max-width: 400px) {
  .form .fieldset.half.date {
    width: 75%;
  }
}

.inline-checkbox .custom-checkbox {
  display: inline-block;
}

.inline-checkbox .custom-checkbox * {
  vertical-align: middle;
}

.inline-checkbox div {
  margin-top: 15px;
  color: grey;
}

.inline-checkbox .custom-checkbox [type="checkbox"] ~ .fake-checkbox {
  margin-left: 10px;
  margin-right: 5px;
  margin-top: 0;
}

span.explain {
  font-size: 14px;
  margin-right: 5px;
  margin-left: 0;
}
@media (max-width: 599px) {
  .form .fieldset.half.form--unlarge {
    width: 100%;
  }
}
</style>
